import { useEffect } from 'react';

import useBranchId from '@maya/hooks/useBranchId';
import useTranslate from '@maya/hooks/useTranslate';
import { useAppDispatch, useAppSelector } from '@maya/store/hooks';
import { loadWages, selectWages } from '@maya/store/slices/payroll';

import type { PaymentStatus } from '@maya/interface';

export default function useWages(employeeId?: string, beforeIsoDate?: string, status?: PaymentStatus) {
  const branchId = useBranchId();
  const t = useTranslate();

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!branchId) {
      return;
    }

    dispatch(loadWages({ branchId, employeeId, beforeIsoDate, status }, t));
  }, [branchId, dispatch, employeeId, beforeIsoDate, status, t]);

  return useAppSelector(selectWages);
}
